module.exports = __webpack_public_path__ + "img/1.20543037.png";